import { fetchNewSearch, getRpg, programUrl } from "../Api/index";
export default {
    state: {
        searchedTvList: null,
        searchedMovieList: null,
        allArchive: null,
        programUrl: null,
        isLoadingSearch: false,
    },
    mutations: {
        SET_SEARCHED_LIST(state, payload) {
            state.searchedTvList = payload.epg;
            state.searchedMovieList = payload.movies;
        },
        set_isLoadingSearch(state, payload) {
            state.isLoadingSearch = payload;
        },
        CLEAR_SEARCHED_LIST(state) {
            state.searchedTvList = null;
            state.searchedMovieList = null;
        },
        SET_ALLARCHIVE(state, payload) {
            const dateNow = Date.now() / 1000;
            const filtered = payload?.filter(
                (item) => item.begin_time <= dateNow && item.url
            );
            state.allArchive = filtered;
        },

        SET_PROGRAM(state, payload) {
            state.programUrl = payload;
        },
    },

    actions: {
        async getSearchedList({ commit }, query) {
            commit("set_isLoadingSearch", true);
            const response = await fetchNewSearch(query);
            commit("SET_SEARCHED_LIST", response);
            commit("set_isLoadingSearch", false);
        },
        async getAllArchive({ commit }, cid) {
            const response = await getRpg(cid, 14, 0);
            commit("SET_ALLARCHIVE", response.programs);
        },
        async gatProggramUrl({ commit }, payload) {
            const { pid, cid, time } = payload;
            const response = await programUrl(
                pid == 0 ? null : pid,
                time == 0 ? null : time,
                cid
            );
            commit("SET_PROGRAM", response);
        },
    },

    getters: {
        getSearchedTvList(state) {
            return state.searchedTvList;
        },
        getSearchedMovieList(state) {
            return state.searchedMovieList;
        },
        getAllArchive(state) {
            return state.allArchive;
        },

        getProgramUrl(state) {
            return state.programUrl;
        },

        getIsLoadingSearch(state) {
            return state.isLoadingSearch;
        },
    },
};
